import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { filter, take } from 'rxjs/operators';
import { FlagKey, FlagService, SearchRelevanceExperimentVariants } from './optimizely';

@Injectable({
	providedIn: 'root',
})
export class SearchRelevanceExperimentsService {
	constructor(private cookieService: CookieService, private flagService: FlagService) {}

	setExperimentCookies(): void {
		this.flagService
			.getVariationKey(FlagKey.searchRelevanceExperiment)
			.pipe(
				take(1),
				filter(
					(variationKey) =>
						variationKey === SearchRelevanceExperimentVariants.ExperimentGroupOneCookie ||
						variationKey === SearchRelevanceExperimentVariants.ExperimentGroupTwoCookie ||
						variationKey === SearchRelevanceExperimentVariants.ExperimentGroupThreeCookie
				)
			)
			.subscribe((variationKey) => {
				if (this.cookieService.check(`cw-${variationKey}`) === false) {
					this.cookieService.set(`cw-${variationKey}`, '1');
				}
			});
	}
}
